import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import AccountsMenu from "./AccountsMenu";
import { NavLink } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom";
import YearsDropDown from "../Shared/YearsDropDown";
import VoucherTypeDropDown from "../Shared/VoucherTypesDropDown";
import Pagination from "../General/Pagination";
import moment from "moment";
import { scrollToTop } from "../Shared/ScrollOnTop";

function GeneralLedger(props) {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [DefaultFYear, setDefaultFYear] = useState(
    localStorage.getItem("DefaultFYear")
  );
  const [VoucherType, setVoucherType] = useState(0);
  const [loading, setLoading] = useState(false);
  const [validated, setValidated] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [searchTrigger, setSearchTrigger] = useState(0);
  const [accountTitle, setAccountTitle] = useState("");
  const [totalDebit, setTotalDebit] = useState("");
  const [totalCredit, setTotalCredit] = useState("");
  const [finalBalance, setFinalBalance] = useState("");

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const fYearParam = urlParams.get("FYear");
    if (fYearParam) {
      setDefaultFYear(fYearParam);
    }
  }, []);

  // pagination
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  let params = useParams();
  const [AccountCode, setAccountCode] = useState(params.accountcode);

  useEffect(() => {
    if (!DefaultFYear) {
      return;
    }
    const fy = parseInt(DefaultFYear, 10);
    if (Number.isNaN(fy)) {
      return;
    }
    const fyStart = moment(`${fy}-04-01`);
    const fyEnd = moment(`${fy + 1}-03-31`);
    const today = moment();
    const defaultEnd = today.isBetween(fyStart, fyEnd, "day", "[]") ? today : fyEnd;
    if (!StartDate) {
      setStartDate(fyStart.format(config.date_format_input));
    }
    if (!EndDate) {
      setEndDate(defaultEnd.format(config.date_format_input));
    }
  }, [DefaultFYear]);

  useEffect(() => {
    if (!AccountCode || !StartDate || !EndDate) {
      return;
    }
    setLoading(true);
    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      pageNo: pageNo,
      pageSize: pageSize,
      FYear: DefaultFYear,
      AccountCode: AccountCode,
      StartDate: StartDate,
      EndDate: EndDate,
    };

    //console.log(data);

    var api_config = {
      method: "post",
      url: config.base_url + "Accounts/GetGeneralLedger",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code != 0) {
          setLedger(response.data.ListofRecords);
          setTotalRecords(response.data.totalRecords);
          setTotalDebit(response.data.TotalDebit);
          setTotalCredit(response.data.TotalCredit);
          setFinalBalance(response.data.FinalBalance);
          setAccountTitle(
            response.data.AccountCode && response.data.AccountDesc
              ? `${response.data.AccountCode} ${response.data.AccountDesc}`
              : ""
          );
        } else {
          setLedger(null);
          setTotalRecords(0);
          setTotalDebit("");
          setTotalCredit("");
          setFinalBalance("");
          setAccountTitle("");
        }
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
      });
  }, [pageNo, pageSize, DefaultFYear, AccountCode, StartDate, EndDate, searchTrigger]);

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const renderLedger = () => {
    if (listOfLedger != null && listOfLedger.length > 0) {
      let count = 1;
      return listOfLedger.map((item, index) => {
        const balanceValue = Number(item.Balance);
        const balanceText =
          !Number.isNaN(balanceValue) && balanceValue < 0
            ? `(${Math.abs(balanceValue)})`
            : item.Balance;
        return (
          <tr key={index}>
            <td>{count++ + pageSize * (pageNo - 1)}</td>
            <td>
              {moment(item.Selected_Voucher.Voucher_date).format(
                config.date_format_input
              )}
            </td>
            <td>
              {item.Selected_Voucher && item.Selected_Voucher.ID ? (
                <NavLink to={`/Accounts/EditVoucher/${item.Selected_Voucher.ID}`}>
                  {item.Selected_Voucher.Voucher_number}
                </NavLink>
              ) : (
                item.Selected_Voucher?.Voucher_number
              )}
            </td>
            <td>{item.Narration}</td>
            <td> {item.Dr_Amt}</td>
            <td>{item.Cr_Amt}</td>
            <td>{balanceText}</td>
          </tr>
        );
      });
    } else {
      return (
        <tr>
          <td colSpan="7">
            <h4
              className="mt-3"
              style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
            >
              No Data Found
            </h4>
          </td>
        </tr>
      );
    }
  };

  return (
    <>
      <AccountsMenu />

      <div className="container body-content">
        <div className="page-head">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <NavLink to="/Dashboard">Dashboard</NavLink>
                    </li>
                    <li className="breadcrumb-item">
                      <NavLink to="/Accounts/AccountsDashboard">
                        Accounts
                      </NavLink>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      General Ledger
                    </li>
                  </ol>
                </nav>
                <div className="page-title">General Ledger</div>
              </div>
              <div className="col-md-6">
                <div className="page-right-actions">
                  <NavLink
                    to="/Accounts/ManageAccounts"
                    className="button button-white button-icon"
                  >
                    Manage Accounts
                    <i className="ri-add-line"></i>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-content">
          <div className="container">
            <div className="card">
              <div className="card-body p-md-4">
                <div className="row gy-3">
                  <div className="col-md-3">
                    <div className="form-group">
                      <label>Selected Account:</label>
                      <input
                        type="text"
                        className="form-control"
                        value={AccountCode}
                        disabled
                      ></input>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label htmlFor="">Start Date:</label>
                      <input
                        type="date"
                        className="form-control"
                        value={StartDate}
                        onChange={(e) => setStartDate(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label htmlFor="">End Date:</label>
                      <input
                        type="date"
                        className="form-control"
                        value={EndDate}
                        onChange={(e) => setEndDate(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="col-md-5 text-end">
                    <div className="form-group">
                      <input
                        type="button"
                        value="Search"
                        className="mt-md-4 button button-primary"
                        onClick={() => {
                          setPageNo(1);
                          setSearchTrigger((prev) => prev + 1);
                        }}
                      />
                      <NavLink
                        target="_blank"
                        className="mt-md-4 button button-primary ms-2"
                        to={`/Accounts/PrintGeneralLedger?FYear=${DefaultFYear || ""}&StartDate=${StartDate || ""}&EndDate=${EndDate || ""}&AccountCode=${AccountCode || ""}`}
                      >
                        Print
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {accountTitle && (
              <div className="card mt-3">
                <div className="card-body">
                  <h5 className="mb-0">{accountTitle}</h5>
                </div>
              </div>
            )}
            <div className="card mt-3">
              <div className="card-body table_card">
                <table className="table table-theme table-hover">
                  <thead>
                    <tr>
                      <th>Sr#</th>
                      <th>Dated</th>
                      <th>Voucher No</th>
                      <th>Narration</th>
                      <th>Debit</th>
                      <th>Credit</th>
                      <th>Balance</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td className="text-center" colSpan="7">
                          <Spinner animation="border" role="status"></Spinner>
                        </td>
                      </tr>
                    ) : (
                      <>{renderLedger()}</>
                    )}
                  </tbody>
                  {listOfLedger && listOfLedger.length > 0 && (
                    <tfoot>
                      <tr>
                        <td colSpan="4" className="text-end">
                          Totals
                        </td>
                        <td>{totalDebit}</td>
                        <td>{totalCredit}</td>
                        <td>
                          {Number(finalBalance) < 0
                            ? `(${Math.abs(Number(finalBalance))})`
                            : finalBalance}
                        </td>
                      </tr>
                    </tfoot>
                  )}
                </table>

                <div className="pagination-wrap">
                  <div className="row align-items-center">
                    <div className="col-md-2 form_default">
                      <div className="d-flex align-items-center">
                        <label className="me-2" style={{ fontSize: "15px" }}>
                          Page Size
                        </label>
                        <div className="form-group">
                          <select
                            className="form-select"
                            style={{ width: "100px" }}
                            value={pageSize}
                            onChange={(e) => {
                              setPageNo(1);
                              setPageSize(parseInt(e.target.value));
                            }}
                          >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="200">200</option>
                            <option value="500">500</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <Pagination
                      pageNo={pageNo}
                      pageSize={pageSize}
                      totalRecords={totalRecords}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GeneralLedger;
